module.exports = __webpack_public_path__ + "static/hero_video-b19f005861b14f296f2fa9f6a2ca0b29.mp4";